import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { BadgesContainer, BorderButton, ProfileHeader, ScreenContainer, UserCard } from "../components"
import AuthStore from "../stores/AuthStore"

export const ProfilePage = observer(() => {
	const { t } = useTranslation()
	const { user, badgesFromEvents } = AuthStore

	return (
		<ScreenContainer>
			<div className="flex flex-col pt-[20px]">
				<ProfileHeader />

				<div className="mt-[54px]">
					<UserCard user={user} />
				</div>

				{/* {showQuestionnairePrompt && (
					<div className="mt-[31px]">
						<QuestionnairePrompt />
					</div>
				)} */}

				{(badgesFromEvents?.length ?? 0) > 0 && (
					<div className="mt-[31px] flex-1">
						<BadgesContainer badgesFromEvents={badgesFromEvents} orientation="horizontal" />
					</div>
				)}

				<div className="my-[20px] flex w-full items-center justify-center self-end justify-self-end">
					<BorderButton text={t("profile.logout_button")} onClick={() => AuthStore.signOut()} />
				</div>
			</div>
		</ScreenContainer>
	)
})
